// src/Hooks/useAbiliBalance.js

import { useQuery } from "@tanstack/react-query";
import { fetchAbiliBalance } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useAbiliBalance(options = {}) {
  const { onSuccess, onError, enabled = true } = options;

  const {
    data,
    error,
    isLoading,
    refetch: reload,
  } = useQuery({
    queryKey: ["abiliBalance"],
    queryFn: async () => {
      try {
        const response = await fetchAbiliBalance();
        return response;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 60, // 60 دقيقة
    cacheTime: 1000 * 60 * 60 * 24, // 24 ساعة
    refetchOnWindowFocus: false,
    onSuccess,
    onError,
  });

  const balance = data?.balance?.balance ?? null;
  const currency = data?.balance?.currency ?? "SYP";
  const lastUpdated = data?.balance?.last_updated ?? null;

  return {
    balance,
    currency,
    lastUpdated,
    error,
    isLoading,
    reload,
  };
}
